// extracted by mini-css-extract-plugin
export default {"loading-icon":"styles_loading-icon__j+dHx"};